import React from "react";
import Icon1 from "../../assets/debit-card.png";
import Icon2 from "../../assets/delivery-status.png";
import Icon3 from "../../assets/delivery-truck.png";
import { useTranslation } from "react-i18next";
const CartBottomMenu = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="mb-4 mt-4">
            <div className="d-flex align-items-start">
              <img src={Icon1} alt="payment" className="me-3" width={50} />
              <div>
                <h6 className="fw-normal mb-1 mt-2">{t("Payment")}</h6>
                <p className="fs-11 mb-0 text-muted">{t("PaymentDesc")}</p>
                <p className="fs-11 mb-0 text-muted">
                  {t("ProductInstallment")}
                </p>
              </div>
            </div>
          </div>
          <hr />
          <div className="mb-4 mt-4">
            <div className="d-flex align-items-start">
              <img
                src={Icon2}
                alt="shipping"
                className="me-3 mt-1"
                width={50}
              />
              <div>
                <h6 className="fw-normal mb-1 mt-2">
                  {t("ShippingAndDelivery")}
                </h6>
                <p className="fs-11 mb-0 text-muted">
                  {t("ShippingAndDeliveryDesc")}
                </p>
              </div>
            </div>
          </div>
          <hr />
          <div className="mb-4 mt-4">
            <div className="d-flex align-items-start">
              <img src={Icon3} alt="returns" className="me-3 mt-1" width={50} />
              <div>
                <h6 className="fw-normal mb-1 mt-2">
                  {t("ReturnsAndExchanges")}
                </h6>
                <p className="fs-11 mb-0 text-muted">
                  {t("ReturnsAndExchangesDesc")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CartBottomMenu;
